export default "__VITE_ASSET__TsDFsCZ4__"